const style = {
  ionicRow: {
    margin: 0,
    padding: 0
  },
  item: {
    marginLeft: 15,
    marginRight: 0,
    marginTop: 10,
    marginBottom: 0,
    padding: 0,
    textAlign: 'center',
    display: 'inline-block',
    cursor: 'pointer'
  },
  itemIcon: {
    margin: 10
  },
  itemText: {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 0,
    paddingBottom: 10
  },
  itemHeader: {
    marginLeft: 30, //>=item.marginLeft + itemIcon.margin
    textAlign: 'center',
    display: 'inline-block',
  },
  icon: {
    margin: 5
  }
}

export default style;



// WEBPACK FOOTER //
// ./src/components/IconPicker/style.js